<template>
  <div class="publish-result-container">
    <i class="icon-publish-progress"></i>
    <div class="result-success-container">
      <i class="icon-result-success"></i>
      <div class="result-text">视频提交成功</div>
      <div class="result-sub-text">若投递稿件没有立刻出现在列表页，请稍等一下</div>
    </div>
    <div class="button-group">
      <pcw-button type="normal" @click="onViewManagementClick">查看管理</pcw-button>
      <pcw-button type="info" @click="onPublishClick">继续发布</pcw-button>
    </div>
  </div>
</template>
<script>
import pcwButton from '@/components/common/button.vue'

export default {
  components: {
    pcwButton,
  },
  methods: {
    onViewManagementClick() {
      this.$router.push('/content-management')
    },
    onPublishClick() {
      this.$router.push('/video-post')
    },
  },
  mounted() {
    window.onbeforeunload = () => {}
  },
}
</script>
<style lang="less">
.publish-result-container {
  .icon-publish-progress {
    display: block;
    width: 458px;
    height: 74px;
    background: transparent url('~~@/assets/videoPost/publish_progress.png') center center no-repeat;
    background-size: contain;
    margin: 134px auto 0;
  }
  .result-success-container {
    margin-top: 30px;
    .icon-result-success {
      display: block;
      width: 260px;
      height: 260px;
      background: transparent url('~~@/assets/videoPost/result_success.png') center center no-repeat;
      background-size: contain;
      margin: 0 auto;
    }
    .result-text {
      margin-top: 22px;
      font-size: 18px;
      line-height: 25px;
      color: #000;
    }
    .result-sub-text {
      margin-top: 12px;
      font-size: 14px;
      line-height: 20px;
      color: #9b9b9b;
    }
  }
  .button-group {
    margin-top: 40px;
    .pcw-button + .pcw-button {
      margin-left: 50px;
    }
  }
}
</style>
